module.exports = __webpack_public_path__ + "img/H-mini.6556d6ae.jpg";